import React, { useMemo } from 'react';

import { useSearchParams } from 'next/navigation';

import AuthenticationButtons from '@editor/components/Header/AuthenticationButtons/AuthenticationButtons';
import { AuthenticationButtonsProps } from '@editor/components/Header/AuthenticationButtons/types';

// All components with useSearchParams should be wrapped in Suspense component
const AuthenticationButtonsWithSearchParams: React.FC<
  Pick<AuthenticationButtonsProps, 'onSignup' | 'showSignInButton' | 'layout'>
> = ({ onSignup, showSignInButton, layout }) => {
  const searchParams = useSearchParams();

  const showSignUpInitially = useMemo(() => {
    return (
      searchParams?.has('error') &&
      searchParams.get('error') === 'authorization-failure'
    );
  }, [searchParams]);

  return (
    <AuthenticationButtons
      layout={layout}
      showSignInButton={showSignInButton}
      showSignUpInitially={showSignUpInitially}
      onSignup={onSignup}
    />
  );
};

export default AuthenticationButtonsWithSearchParams;
